module.exports = __webpack_public_path__ + "static/media/London.ad2d94d8.jpg";